<template>
  <div
    v-if="description"
    :class="reviewCardClass"
  >
    <div class="c-review-card__container">
      <div class="c-review-card__stars u-margin-bottom-small">
        <span
          v-for="i in 5"
          :key="i"
          class="c-review-card__star"
        >
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 22 22"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          ><g
            id="PLP---Collections-Page"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          ><g
            id="D-PLP-2.1-Hero-Option-2.1"
            transform="translate(-649.000000, -3832.000000)"
            :fill="i > rating ? '#E5E5E5' : '#FFD656'"
            fill-rule="nonzero"
          ><g
            id="Testimonial"
            transform="translate(0.000000, 3752.000000)"
          ><g
            id="Inner-Content"
            transform="translate(362.000000, 80.000000)"
          ><g
            id="Stars"
            transform="translate(287.000000, 0.000000)"
          ><g id="noun_Star_258325"><polygon
            id="Path"
            points="11 0 8.4103139 8.40566038 0 8.40566038 6.80717489 13.5943396 4.19282511 22 11 16.8113208 17.8071749 22 15.1928251 13.5943396 22 8.40566038 13.5896861 8.40566038"
          /></g></g></g></g></g></g></svg>
        </span>
      </div>
      <p
        v-if="title"
        class="t-heading-7 u-margin-bottom-x-small"
      >
        {{ title }}
      </p>
      <blockquote class="c-review-card__quote t-paragraph u-margin-bottom-small">
        <wysiwyg 
          :class="wysiwygClass"
          :html="description"
        />
      </blockquote>
      <p
        v-if="author"
        :class="authorClass"
      >
        {{ author }}
      </p>
      <p
        v-if="authorType"
        class="c-review-card__verified t-heading-10 u-margin-bottom-xx-large"
      >
        {{ authorType }}
      </p>
      <btn
        v-if="showCta"
        v-bind="cta"
      >
        {{ cta.text }}
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from "../button/Btn";
import Wysiwyg from "../wysiwyg/Wysiwyg";
export default {
  name: "ReviewHighlight",
  components: {
    Wysiwyg,
    Btn,
  },
  props:{
    titleTypography: {
      type: String,
      default: 't-heading-7'
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    descriptionMarginBottom: {
      type: String,
      default: 'medium'
    },
    descriptionColor: {
      type: String,
      default: '',
    },
    whiteText: {
      type: Boolean,
      default: false
    },
    author: {
      type: String,
      default: ""
    },
    authorType: {
      type: String,
      default: ''
    },
    cta: {
      type: Object,
      default:  () => ({})
    },
    textAlignment: {
      type: String,
      default: 'left',
    },
    rating: {
      type: Number,
      default: 5
    }
  },
  computed: {
    reviewCardClass() {
      let result = ['c-review-card']
      result.push(`u-text-align-${this.textAlignment}`)
      return result
    },
    authorClass() {
      let result = 't-heading-9 u-margin-bottom-xx-large'
      if (this.authorType) {
        result = 't-heading-9 u-margin-bottom-x-small'
      }
      return result
    },
    showCta() {
      const cta = this.cta
      return Object.keys(cta).length > 0
    },
    wysiwygClass() {
      let wysiwygClass = [];
      if (this.cta) {
        wysiwygClass.push("u-margin-bottom-" + this.descriptionMarginBottom);
      }
      if (this.whiteText) {
        wysiwygClass.push("u-foreground-white");
      }
      if (this.descriptionColor) {
        wysiwygClass.push(this.titleTypography + '--' + this.descriptionColor);
      }
      else if (this.titleColor) {
        wysiwygClass.push(this.titleTypography + '--' + this.titleColor);
      }
      return wysiwygClass;
    },
  }
}
</script>

<style lang="scss" scoped>
	.c-review-card {
    padding: rem(20px);
		text-align: center;
    /*min-width: 420px;*/
    &__container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }

		&__quote {
			max-width: rem(700px);
			margin:0 auto;
		}
    &--star {
      padding:0 rem(5px);
    }

    &__verified {
      @include themify($themes) {
        color: themed('accent', 'base');
      }
    }
	}
</style>
